import React, { Component } from 'react';

import { getJSON } from '../constants/network';
import routes from '../constants/routes';

export default class extends Component {

    state = { data: null };

    componentDidMount = () => {
        getJSON(routes.info)
            .then(result => {
                this.setState({
                    data: result.data
                });
            });
    };

    render() {
        const { data } = this.state;
        if (data) {
            return (
                <div className="container">
                    <div className="col-sm-1">
                        <a href="http://www.grupoapok.com" target="_blank" rel="noopener noreferrer">
                            <img src="http://grupoapok.com/develop/ave-apok-gray.png" alt=""/>
                        </a>
                    </div>
                    <div className="col-sm-11">
                        <a href="/#/contacto">Contáctanos</a>
                        <ul className="otros-link pull-right">
                            <li className="hidden"><a href="/">Nosotros</a></li>
                            <li className="hidden"><a href="/">Aviso Legal</a></li>
                            <li><a href="/#/privacidad">Política de Privacidad</a></li>
                        </ul>
                        <ul className="link-social-ul pull-right">
                            <li>
                                <a target='_blank' rel='noopener noreferrer' className='link-social'
                                   href={data.facebook}>
                                    <i className='fa fa-facebook'/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel='noopener noreferrer' className='link-social'
                                   href={`https://www.instagram.com/${data.instagram}`}>
                                    <i className='fa fa-instagram'/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel='noopener noreferrer' className='link-social'
                                   href={`https://www.instagram.com/${data.twitter}`}>
                                    <i className='fa fa-twitter'/>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            )
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js